<template>
    <div class="bodys">

        <q-dialog v-model="dialogCodigo" persistent transition-show="flip-down" transition-hide="flip-up">
            <q-card class="bg-primary text-white">
                <q-bar>
                    <div>Código de Verificación</div>
                    <q-space />
                    <q-btn dense flat icon="close" v-close-popup>
                        <q-tooltip content-class="bg-white text-primary">Close</q-tooltip>
                    </q-btn>
                </q-bar>

                <q-card-section v-if="codigoRecibido == false" class="q-py-xl">
                    <q-input style="width: 500px;" filled label-color="white" dark color="white" class="text-white"
                        v-model="correoUsuario" type="usuario" label="Correo del Usuario" />
                </q-card-section>

                <q-card-section v-if="codigoRecibido == true && usuaioCambio == null" class="q-py-xl">
                    <div class="row justify-center q-gutter-sm">
                        <q-input v-for="(char, index) in code" :key="index" v-model="code[index]" filled maxlength="1"
                            class="code-input text-white" @input="focusNext(index, $event)"
                            @keydown.backspace="focusPrev(index, $event)" ref="inputs" label-color="white" dark
                            color="white" />
                    </div>
                </q-card-section>

                <q-card-section v-if="usuaioCambio != null" class="q-py-xl">
                    <div class="row justify-center q-gutter-sm">
                        <q-input filled label-color="white" style="width: 250px;" color="white" class="text-white"
                            v-model="nuevaContraseña" label="Contraseña" dark :type="isPwd ? 'password' : 'text'">
                            <template v-slot:append>
                                <q-icon :name="isPwd ? 'mdi-eye-off' : 'mdi-eye-outline'" class="cursor-pointer"
                                    @click="isPwd = !isPwd" />
                            </template>
                        </q-input>
                    </div>
                </q-card-section>

                <q-card-actions v-if="codigoRecibido == false" class="q-ml-lg q-mr-lg ">
                    <template>
                        <q-btn unelevated color="primary" class="full-width" @click="enviarCodigo()"
                            label="ENVIAR CÓDIGO" />
                    </template>
                </q-card-actions>

                <q-card-actions v-if="codigoRecibido == true && usuaioCambio == null" class="q-ml-lg q-mr-lg ">
                    <template>
                        <q-btn unelevated color="primary" class="full-width" @click="validarCodigo()"
                            label="VALIDAR CODIGO" />
                    </template>
                </q-card-actions>

                <q-card-actions v-if="usuaioCambio != null" class="q-ml-lg q-mr-lg ">
                    <template>
                        <q-btn unelevated color="primary" class="full-width" @click="actualizarContraseña()"
                            label="ACTUALIZAR CONTRASEÑA" />
                    </template>
                </q-card-actions>
            </q-card>
        </q-dialog>

        <div>
            <form v-if="formlogin" class="formulario">
                <q-card class="shadow-0 transparent">
                    <q-card-section>
                        <h2 class="create-account">Iniciar Sesión</h2>
                    </q-card-section>

                    <q-card-section class="q-ml-lg q-mr-lg">
                        <q-form class="q-gutter-md">
                            <q-input filled label-color="white" dark color="white" class="text-white" v-model="nombreU"
                                type="usuario" label="Correo" />
                            <q-input @keyup.enter="validaUsuarioYPassword()" filled label-color="white" color="white"
                                class="text-white" v-model="passwordU" label="Contraseña" dark
                                :type="isPwd ? 'password' : 'text'">
                                <template v-slot:append>
                                    <q-icon :name="isPwd ? 'mdi-eye-off' : 'mdi-eye-outline'" class="cursor-pointer"
                                        @click="isPwd = !isPwd" />
                                </template>
                            </q-input>
                        </q-form>

                    </q-card-section>
                    <q-card-actions class="q-ml-lg q-mr-lg ">
                        <template>
                            <q-btn unelevated color="primary" class="full-width" @click="validaUsuarioYPassword()"
                                label="Validar acceso" />

                            <q-btn flat color="white" class="full-width q-mt-md" label="Olvide mi Contraseña"
                                @click="cambiarContreseña()" />
                            <!-- <q-btn flat color="white" class="full-width q-mt-md" label="REGISTRARSE"
                                @click="formlogin = false" /> -->
                        </template>
                    </q-card-actions>
                </q-card>
            </form>

            <form v-else class="formulario ">
                <q-card class="shadow-0 transparent">
                    <q-card-section>
                        <h2 class="create-account">Seleccionar Estado</h2>
                    </q-card-section>

                    <q-card-section class="q-ml-lg q-mr-lg">
                        <q-form class="q-gutter-md">
                            <q-select v-model="estado" class="text-white" :options="itemsEstados" option-label="estado"
                                filled label="Estado" dark />
                        </q-form>
                    </q-card-section>
                    <q-card-actions class="q-ml-lg q-mr-lg">
                        <template>
                            <q-btn unelevated color="primary" class="full-width" @click="login()"
                                label="Iniciar Sesión" />
                            <q-btn flat color="white" class="full-width q-mt-md" @click="CancelarInicio()"
                                label="CANCELAR" />
                        </template>
                    </q-card-actions>
                </q-card>
            </form>

            <!-- <form v-if="!formlogin" class="formulario ">
                <q-card class="shadow-0 transparent">
                    <q-card-section>
                        <h2 class="create-account">Registrarse</h2>
                    </q-card-section>

                    <q-card-section class="q-ml-lg q-mr-lg">
                        <q-form class="q-gutter-md">
                            <q-input filled label-color="white" dark color="white" class="text-white"
                                v-model="registro.email" type="correo" label="Correo" />
                            <q-input filled label-color="white" color="white" class="text-white"
                                v-model="registro.nombre" type="nombre" label="Nombre" dark />
                            <q-input filled label-color="white" color="white" class="text-white"
                                v-model="registro.apellidos" type="apellidos" label="Apellidos" dark />
                            <q-input filled label-color="white" color="white" class="text-white"
                                v-model="registro.telefono" type="telefono" label="Teléfono" dark />
                            <q-select v-model="registro.genero" class="text-white" :options="['Femenino', 'Masculino']"
                                filled label="Género" dark />
                            <q-input filled label-color="white" color="white" class="text-white"
                                v-model="registro.password" type="password" label="Contraseña" dark />

                        </q-form>
                    </q-card-section>
                    <q-card-actions class="q-ml-lg q-mr-lg">

                        <template>
                            <q-btn unelevated color="primary" class="full-width" @click="guardarEmpleado()"
                                label="REGISTRARSE" />
                            <q-btn flat color="white" class="full-width q-mt-md" @click="formlogin = true"
                                label="CANCELAR" />
                        </template>
                    </q-card-actions>
                </q-card>
            </form> -->
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { QSpinnerCube } from 'quasar'
import { QSpinnerGears } from 'quasar';
export default {
    data() {
        return {
            formlogin: true,

            passwordU: '',
            nombreU: "",
            isPwd: true,

            registro: {
                _id: '',
                email: '',
                nombre: '',
                apellidos: '',
                password: '',
                fechaNacimiento: '',
                genero: '',
                estatus: 'active',
                telefono: '',
                rol: 'Administrador',
                fechaCreacion: ''
            },

            dialogCodigo: false,
            correoUsuario: '',
            code: Array(8).fill(""),

            codigoRecibido: false,
            usuaioCambio: null,
            nuevaContraseña: '',

            formEstado: false,
            itemsEstados: [],
            estado: { estado: '' }
        };
    },
    computed: {
        fechaMasked() {
            moment.locale('es-mx');
            return this.fechaNacimiento ? moment.utc(this.fechaNacimiento).format('DD/MMMM/yyyy') : ''
        },
    },
    created() {
        // this.GetEstados()
    },
    methods: {
        async validaUsuarioYPassword() {
            const nombre = this.nombreU;
            const password = this.passwordU
            if (nombre == '') {
                this.$q.notify({ type: 'info', icon: 'mdi-information', message: 'Ingrese un nombre de usuario.', timeout: 2000 })
                return
            }
            if (password == '') {
                this.$q.notify({ type: 'info', icon: 'mdi-information', message: 'Ingrese su contraseña.', timeout: 2000 })
                return
            }

            this.$q.loading.show({ message: '<b>Validando datos...</b>' })
            try {
                let response = await axios.get(`Login/ValidaUsuarioAsync/${nombre}/${password}`);
                console.log(response.data)
                this.$q.loading.hide();
                this.itemsEstados = response.data
                this.formlogin = false
            } catch (error) {
                console.log(error)
                this.$q.notify({ type: 'negative', message: error.response.data });
                this.$q.loading.hide();
            }
        },

        async guardarEmpleado() {
            if (this.registro.email == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique el correo electronico.' })
                return;
            }
            if (this.registro.nombre == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique el nombre del usuario' })
                return;
            }
            if (this.registro.apellidos == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique sus apelleidos' })
                return;
            }
            if (this.registro.telefono == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique su número telefonico' })
                return;
            }
            if (this.registro.genero == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique el género' })
                return;
            }
            if (this.registro.password == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique una contraseña segura' })
                return;
            }

            this.$q.loading.show({ spinner: QSpinnerCube, spinnerColor: 'white', spinnerSize: 140, message: 'Registrando usuario. Espere...', messageColor: 'white' })

            this.registro.fechaCreacion = moment().format('YYYY/MM/DD')

            try {
                let response = await axios.post(`Login/PostRegistroNuevo/`, this.registro)
                console.log(response)

                this.$q.loading.hide()
                this.$q.notify({ type: 'positive', message: `La cuenta se ha creado exitosamente.` })
                this.$q.notify({ position: 'top-right', type: 'positive', message: `Puede acceder con su nombre de usuario y password.` })
                this.registro = {
                    _id: '',
                    email: '',
                    nombre: '',
                    apellidos: '',
                    password: '',
                    fechaNacimiento: '',
                    genero: '',
                    estatus: 'active',
                    telefono: '',
                    rol: 'Administrador',
                    fechaCreacion: ''
                }

                this.formlogin = true
            } catch (error) {
                console.log(error)
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', message: error.response.data, color: 'red' })
            }

        },

        async login() {
            if (this.estado.estado == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', icon: 'mdi-information', message: 'Seleccione el estado para acceder a su información.', timeout: 2000 })
                return
            }
            let objeto = {
                username: this.nombreU,
                estado: this.estado.estado,
                baseDatos: this.estado.baseDatos
            }
            this.$q.loading.show({ message: '<b>Iniciando Sesión...</b>' })
            try {
                let response = await axios.post(`Login/PostLoginAsync/`, objeto);
                console.log(response.data)

                this.$store.dispatch("guardarToken", response.data);
                this.$router.push({ name: "Inicio" });
                this.$q.loading.hide();
                this.nombreU = "";
                this.password = "";
            } catch (error) {
                console.log(error)
                this.$q.loading.hide();
                this.$q.notify({ type: 'negative', message: error.response.data });
            }
        },

        cambiarContreseña() {
            this.codigoRecibido = false
            this.nuevaContraseña = ''
            this.usuaioCambio = null
            this.dialogCodigo = true
        },

        async enviarCodigo() {

            if (this.correoUsuario == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique el correo electrónico registrado.' })
                return;
            }

            let objeto = {
                _id: '',
                _id_usuario: '',
                codigo: '',
                estatus: 'PENDIENTE',
                fechaCambio: moment().format('YYYY-MM-DD HH:mm:ss'),
                correo: this.correoUsuario
            }

            try {
                let response = await axios.post(`Login/PostCambioContraseña/`, objeto)
                console.log(response)

                this.$q.notify({ type: 'positive', position: 'top-right', message: 'Código enviado al correo.', color: 'green' })
                this.codigoRecibido = true

            } catch (error) {
                console.log(error)
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', message: error.response.data, color: 'red' })
            }
        },

        async validarCodigo() {

            if (this.code == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique el código de verificación.' })
                return;
            }
            let codigo = this.code.join('')
            try {
                let response = await axios.get('Login/GetValidaCodigo/' + this.correoUsuario + '/' + codigo)
                console.log(response)
                this.$q.notify({ type: 'positive', position: 'top-right', message: 'Código correcto.', color: 'green' })

                this.usuaioCambio = response.data

            } catch (error) {
                console.log(error)
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', message: error.response.data, color: 'red' })
                this.usuaioCambio = null

            }
        },

        async actualizarContraseña() {

            let objeto = {
                _id_usuario: this.usuaioCambio._id,
                codigo: this.code.join(''),
                correo: this.correoUsuario,
                pass: this.nuevaContraseña,
                fechaCambio: moment().format('YYYY-MM-DD HH:mm:ss'),
                estatus: "REALIZADO"
            }

            try {
                let response = await axios.put('Login/PutPassword/', objeto)
                console.log(response)
                this.$q.notify({ type: 'positive', position: 'top-right', message: 'Contraseña actualizada.', color: 'green' })

                this.codigoRecibido = false
                this.nuevaContraseña = ''
                this.usuaioCambio = null
                this.dialogCodigo = false


            } catch (error) {
                console.log(error)
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', message: error.response.data, color: 'red' })
            }
        },

        CancelarInicio() {
            this.formlogin = true
            this.estado = {}
            this.passwordU = ''
            this.nombreU = ""
        },

        focusNext(index, event) {
            if (event && event.length === 1 && index < this.code.length - 1) {
                this.$refs.inputs[index + 1].focus();
            }
        },

        focusPrev(index, event) {
            if (!this.code[index] && index > 0) {
                this.$refs.inputs[index - 1].focus();
            }
        },

        async GetEstados() {
            try {
                let response = await axios.get('Login/GetEstados/')
                console.log(response)
                this.itemsEstados = response.data
            } catch (error) {
                console.log(error)
            }
        },
    }
};
</script>

<style scoped>
.code-input {
    width: 40px;
    text-align: center;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Roboto', sans-serif;
}

.bodys::after {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* background: linear-gradient(to bottom, #154F39, #fff); */
    background: url('/fondo.jpg') center/cover no-repeat;
    z-index: -1;
}

.bodys {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    /* background-image: url('../assets/color14.png'); */
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    /* Hace que el fondo sea fijo */
    color: #fff;
}

.container-form {
    width: 80%;
    height: 70vh;
    display: flex;
    justify-content: space-between;
    transition: all 0.5s ease-out;
}

.welcome-back {
    display: flex;
    align-items: center;
    height: 50vh;
    text-align: center;
    padding: 3rem;
}

.message {
    padding: 1rem;
}

.message h2 {
    font-size: 1.7rem;
    padding: 1rem 0;
}

/* .message button {
    padding: 1rem;
    font-weight: 400;
    background-color: #4a4aee;
    border-radius: 2rem;
    border: none;
    outline: none;
    cursor: pointer;
    font-size: 0.9rem;
    margin-top: 2rem;
    transition: all 0.3s ease-in;
    color: #fff;
} */

.message button:hover {
    background-color: #6464f8;
}

.formulario {
    width: 500px;
    height: fit-content;
    padding-bottom: 3rem;
    background-color: rgba(26, 48, 19, 0.302);
    text-align: center;
}

.formulario-dos {
    width: 700px;
    /* padding: 1rem; */
    padding-bottom: 3rem;
    height: fit-content;
    /* margin: 2rem; */
    background-color: rgba(51, 51, 51, 0.6);
    text-align: center;
}

.create-account {
    font-size: 2rem;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    unicode-bidi: isolate;
}

.iconos {
    width: 200px;
    display: flex;
    justify-content: space-around;
    margin: auto;
}

.border-icon {
    height: 20px;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.5rem;
    border: solid thin white;
    border-radius: 50%;
    font-size: 1.5rem;
    transition: all 0.3s ease-in;
}

.border-icon:hover {
    background-color: #4a4aee;
    cursor: pointer;
}

.cuenta-gratis {
    padding: 1rem 0;
}

.formulario input {
    width: 70%;
    display: block;
    margin: auto;
    margin-bottom: 2rem;
    background-color: transparent;
    border: none;
    border-bottom: white thin solid;
    text-align: center;
    outline: none;
    padding: 0.2rem 0;
    font-size: 0.9rem;
    color: white;
}

.formulario input[type="submit"] {
    width: 60%;
    margin: auto;
    border: solid thin white;
    padding: 0.7rem;
    border-radius: 2rem;
    background-color: white;
    font-weight: 600;
    margin-top: 3rem;
    font-size: 0.8rem;
    cursor: pointer;
    color: #222;
}

@media (max-width: 1200px) {
    .container-form {
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    /* .contenedor-uno {
        display: none;
    } */
}
</style>